import './radio-input.css';

function RadioInput({ label, className, name, value, checked, onChange = () => {} }) {
    return (
        <label className={`radio-container ${className}`}>
            <input
                type='radio'
                name={name}
                value={value}
                checked={checked}
                onChange={onChange}
                />
            <span className="checkmark"></span>
            {label}
        </label>
    );
}

export default RadioInput;